import Style from './style.module.scss'
import useHook from './hooks'
import { Row, Col, Space } from 'antd'
import CustomTable from '../../components/CustomTable'

export default function ExpressH5() {
  const { orderInfo, orderId } = useHook()

  const stateColorDict: any = {
    1: 'rgb(255, 98, 0)',
    2: 'rgb(3, 134, 64)',
  }
  const stateTextDict: any = {
    1: '待收货',
    2: '已验收',
  }
  const orderNoRender = (text: any, record: any, index: number) => {
    return index + 1 + ''
  }
  const listColumn = [
    {
      key: 'index',
      dataIndex: 'index',
      title: '序号',
      render: orderNoRender,
      width: 50,
    },
    {
      key: 'productCode',
      dataIndex: 'productCode',
      title: '物料编码',
      width: 100,
      ellipsis: true,
    },
    {
      key: 'brand',
      dataIndex: 'brand',
      title: '品牌',
      width: 140,
    },
    {
      key: 'productName',
      dataIndex: 'productName',
      title: '商品名称',
      width: 150,
    },
    {
      key: 'manuCode',
      dataIndex: 'manuCode',
      title: '型号',
      width: 150,
    },
    {
      key: 'unit',
      dataIndex: 'unit',
      title: '单位',
      width: 80,
    },
    {
      key: 'productPrice',
      dataIndex: 'productPrice',
      title: '单价',
      width: 100,
    },
    {
      key: 'shipQty',
      dataIndex: 'shipQty',
      title: '已发数量',
      width: 100,
    },
  ]
  return (
    <div className={Style.main}>
      <p className={Style.title}>采购订单号：{orderId}</p>
      {orderInfo.map((item: any) => {
        return (
          <>
            <div
              style={{
                background: stateColorDict[item?.state],
                color: 'white',
                padding: '5px 10px',
              }}
            >
              <Row className={Style['delivery-info']}>
                <Col span={18}>
                  <Space size={'middle'}>
                    <div>发货时间：{item?.deliveryTime}</div>
                    <div>物流公司：{item?.logisticsCompany}</div>
                    <div>快递单号：{item?.trackNum}</div>
                    <div>状态：{stateTextDict[item?.state]}</div>
                  </Space>
                </Col>
              </Row>
            </div>
            <CustomTable
              dataSource={item?.shipProductDTOList}
              columns={listColumn}
            ></CustomTable>
          </>
        )
      })}
    </div>
  )
}
import Style from './style.module.scss'
import useHook from './hooks'
import { Row, Col, Space } from 'antd'
import CustomTable from '../../components/CustomTable'

export default function ExpressH5() {
  const { orderInfo, orderId } = useHook()

  const stateColorDict: any = {
    1: 'rgb(255, 98, 0)',
    2: 'rgb(3, 134, 64)',
  }
  const stateTextDict: any = {
    1: '待收货',
    2: '已验收',
  }
  const orderNoRender = (text: any, record: any, index: number) => {
    return index + 1 + ''
  }
  const listColumn = [
    {
      key: 'index',
      dataIndex: 'index',
      title: '序号',
      render: orderNoRender,
      width: 50,
    },
    {
      key: 'productCode',
      dataIndex: 'productCode',
      title: '物料编码',
      width: 100,
      ellipsis: true,
    },
    {
      key: 'brand',
      dataIndex: 'brand',
      title: '品牌',
      width: 140,
    },
    {
      key: 'productName',
      dataIndex: 'productName',
      title: '商品名称',
      width: 150,
    },
    {
      key: 'manuCode',
      dataIndex: 'manuCode',
      title: '型号',
      width: 150,
    },
    {
      key: 'unit',
      dataIndex: 'unit',
      title: '单位',
      width: 80,
    },
    {
      key: 'productPrice',
      dataIndex: 'productPrice',
      title: '单价',
      width: 100,
    },
    {
      key: 'shipQty',
      dataIndex: 'shipQty',
      title: '已发数量',
      width: 100,
    },
  ]
  return (
    <div className={Style.main}>
      <p className={Style.title}>采购订单号：{orderId}</p>
      {orderInfo.map((item: any) => {
        return (
          <>
            <div
              style={{
                background: stateColorDict[item?.state],
                color: 'white',
                padding: '5px 10px',
              }}
            >
              <Row className={Style['delivery-info']}>
                <Col span={18}>
                  <Space size={'middle'}>
                    <div>发货时间：{item?.deliveryTime}</div>
                    <div>物流公司：{item?.logisticsCompany}</div>
                    <div>快递单号：{item?.trackNum}</div>
                    <div>状态：{stateTextDict[item?.state]}</div>
                  </Space>
                </Col>
              </Row>
            </div>
            <CustomTable
              dataSource={item?.shipProductDTOList}
              columns={listColumn}
            ></CustomTable>
          </>
        )
      })}
    </div>
  )
}
